import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteCollection,
  fetchCollections,
} from '../../../store/landscapeAPI/collection/reducers/collection.slice';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import { ReportingDetailsCollectionsTemplate } from '../../templates';
import cn from 'classnames';
import styles from './ReportingDetailsCollectionsPage.module.css';

interface ReportingDetailsCollectionsPageProps {}

const ReportingDetailsCollectionsPage: FC<
  ReportingDetailsCollectionsPageProps
> = () => {
  const { collections, status } = useSelector(
    (state: RootState) => state.collectionSlice
  );

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    dispatch(fetchCollections());
  }, [dispatch]);

  const handleDeleteCollection = (id: string) => {
    dispatch(deleteCollection(id));
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <div className={cn(styles.wrapper)}>
      <ReportingDetailsCollectionsTemplate
        data={collections ?? []}
        handleDeleteCollection={handleDeleteCollection}
      />
    </div>
  );
};

export default ReportingDetailsCollectionsPage;
